import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SessionService } from '../../Util/Session/session.service';


@Injectable({
  providedIn: 'root'
})
export class UploadMasterService {

  constructor(
    private http: HttpClient,
    private session: SessionService,
  ) {
    try {
      environment.API_URL = this.session.GetUserDetails().ApiUrl;
    } catch (e) { }
  }

  CommonMasterExcelupload(file: File, EmployeeDetail: any) {
    const formData = new FormData();

    // Append the file
    formData.append('file', file, file.name);

    // Append other form data as JSON string
    formData.append('employeeDetail', JSON.stringify(this.session.SetClass(EmployeeDetail)));

    // OR append each property individually
    Object.keys(EmployeeDetail).forEach(key => {
      formData.append(key, EmployeeDetail[key]);
    });

    return this.http.post<any>(environment.API_URL + `CommonMasterExcel/upload`,
      formData
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  ESS_ExcelUploadFileLogsLoad(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_ExcelUploadFileLogs/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }
}
